/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Disabled_MsgInputs */

const en_disabled_websites_disabled_msg = /** @type {(inputs: Disabled_Websites_Disabled_MsgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} has been disabled`)
};

const es_disabled_websites_disabled_msg = /** @type {(inputs: Disabled_Websites_Disabled_MsgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} ha sido deshabilitado`)
};

/**
* | output |
* | --- |
* | "{hostname} has been disabled" |
*
* @param {Disabled_Websites_Disabled_MsgInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_disabled_msg = /** @type {((inputs: Disabled_Websites_Disabled_MsgInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Disabled_MsgInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_disabled_msg(inputs)
	return en_disabled_websites_disabled_msg(inputs)
});